import { Link } from 'react-router-dom'
import { Button } from '../ui/button'
import { useI18n } from '../../i18n'
import { useScrollAnim } from '../../hooks/use-scroll-anim'
import { MessageSquare, Mail } from 'lucide-react'

export function PricingContactCTA() {
  const { t } = useI18n()
  const { ref, isVisible } = useScrollAnim()

  return (
    <section ref={ref} className="py-8 pb-16">
      <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-orange-50 via-amber-50/50 to-violet-50/30 border border-orange-100/60 p-8 md:p-12 text-center">
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-0 left-1/4 w-64 h-64 bg-orange-300 rounded-full blur-[128px]" />
            <div className="absolute bottom-0 right-1/4 w-48 h-48 bg-violet-300 rounded-full blur-[96px]" />
          </div>
          <div className="relative z-10">
            <h2 className="text-2xl font-bold text-[#1a1a1a] mb-3">
              {t('需要定制化方案？', 'Need a Custom Solution?')}
            </h2>
            <p className="text-gray-500 text-sm max-w-md mx-auto mb-6">
              {t(
                '无论您是大型企业或有特殊需求，我们的团队可以为您量身定制专属方案。',
                'Whether you are a large enterprise or have special requirements, our team can tailor a plan for you.'
              )}
            </p>
            <div className="flex items-center justify-center gap-4">
              <Link to="/about">
                <Button className="bg-orange-500 hover:bg-orange-600 text-white h-10 text-sm font-medium rounded-xl px-6">
                  <MessageSquare className="h-4 w-4 mr-2" />
                  {t('联系销售', 'Contact Sales')}
                </Button>
              </Link>
              <a href="mailto:sales@primebook.ai">
                <Button variant="outline" className="border-orange-200 text-orange-600 hover:bg-orange-50 hover:text-orange-700 h-10 text-sm font-medium rounded-xl px-6">
                  <Mail className="h-4 w-4 mr-2" />
                  {t('发送邮件', 'Send Email')}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
